import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert } from "reactstrap";
import { getFeaturesByValuation } from "../../../../services/ValitanApiService";

const FeaturesTab = ({ valuationId }) => {
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!valuationId) return;

        const fetchFeatures = async () => {
            try {
                setLoading(true);
                const response = await getFeaturesByValuation(valuationId);

                if (
                    response.status === 200 &&
                    response.data?.data?.content &&
                    response.data.data.content.length
                ) {
                    setFeatures(response.data.data.content);
                } else {
                    setFeatures([]);
                }
            } catch (error) {
                console.error("Failed to fetch features:", error);
                setFeatures([]);
            } finally {
                setLoading(false);
            }
        };

        fetchFeatures();
    }, [valuationId]);

    if (loading) {
        return (
            <div className="text-center my-3">
                <Spinner color="primary" />
            </div>
        );
    }

    if (!features.length) {
        return <Alert color="info">No features available</Alert>;
    }

    return (
        <div>
            <h5 className="mb-3 text-primary">Property Features</h5>
            <Table bordered hover responsive>
                <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>Boundary Wall</th>
                        <th>Gate Type</th>
                        <th>Water Source</th>
                        <th>Solar Installed</th>
                        <th>Garage</th>
                        <th>Landscape</th>
                    </tr>
                </thead>
                <tbody>
                    {features.map((feature, index) => (
                        <tr key={feature.id}>
                            <td>{index + 1}</td>
                            <td>{feature.boundary_wall ? "Yes ✅" : "No ❌"}</td>
                            <td>{feature.gate_type || "-"}</td>
                            <td>{feature.water_source || "-"}</td>
                            <td>{feature.solar_installed ? "Yes ☀️" : "No"}</td>
                            <td>{feature.garage ? "Yes 🚗" : "No"}</td>
                            <td>{feature.landscape || "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default FeaturesTab;
